import { useState, useEffect } from 'react';
import {CheckCircle, MessageCircleDashed as MessageCircle, Upload} from 'lucide-react';
import { usePageSettings } from '@/hooks/usePageSettings';

export default function Confirmation() {
  const { getSetting, saveSetting } = usePageSettings();
  const [testimonialImages, setTestimonialImages] = useState<string[]>(['', '', '']);
  const [isLoading, setIsLoading] = useState(true);

  // Carregar imagens salvas ao montar o componente
  useEffect(() => {
    const loadSavedImages = async () => {
      try {
        console.log('🔄 Carregando relatos salvos...');
        const confirmation1 = await getSetting('confirmation_testimonial_1');
        const confirmation2 = await getSetting('confirmation_testimonial_2');
        const confirmation4 = await getSetting('confirmation_testimonial_4');

        console.log('📸 Relatos carregados:');
        console.log('Relato 1:', confirmation1 ? 'SIM' : 'NÃO');
        console.log('Relato 2:', confirmation2 ? 'SIM' : 'NÃO');
        console.log('Relato 4:', confirmation4 ? 'SIM' : 'NÃO');

        setTestimonialImages([confirmation1 || '', confirmation2 || '', confirmation4 || '']);
      } catch (error) {
        console.error('❌ Erro ao carregar relatos:', error);
      } finally {
        setIsLoading(false);
      }
    };

    loadSavedImages();
  }, []);

  const handleTestimonialImageUpload = (index: number) => async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      console.log(`📸 Relato ${index + 1} selecionado:`, file.name);
      const reader = new FileReader();
      reader.onload = async (event) => {
        const imageData = event.target?.result as string;
        console.log(`📸 Relato ${index + 1} carregado, tamanho:`, imageData.length);
        const newImages = [...testimonialImages];
        newImages[index] = imageData;
        setTestimonialImages(newImages);

        // Salvar no banco de dados
        try {
          console.log(`💾 Salvando relato ${index + 1}...`);
          await saveSetting(`confirmation_testimonial_${index + 1}`, imageData);
          console.log(`✅ Relato ${index + 1} salvo!`);
          alert(`✅ Relato ${index + 1} salvo com sucesso! Recarregue a página para ver.`);
        } catch (error) {
          console.error(`❌ Erro ao salvar relato ${index + 1}:`, error);
          alert(`❌ Erro ao salvar relato ${index + 1}. Verifique o console.`);
        }
      };
      reader.readAsDataURL(file);
    }
  };



  const deeperTestimonials = [
  {
    text: "Durante anos, carreguei um padrão de autossabotagem que destruía tudo o que eu construía. A Mônica não apenas identificou a origem, mas me guiou em um processo de reequilíbrio que transformou minha relação comigo mesma. Hoje consigo sustentar meu crescimento.",
    author: "Fernanda L., Coach"
  },
  {
    text: "Sempre me relacionei com homens emocionalmente indisponíveis. Achava que era coincidência até a leitura revelar o padrão inconsciente que me fazia escolher esse tipo de relação. Após o processo, tudo mudou. Hoje estou em um relacionamento saudável pela primeira vez.",
    author: "Paula M., Advogada"
  },
  {
    text: "Minha energia era drenada constantemente e eu não sabia por quê. Vivia exausta, sem conseguir avançar profissionalmente. O processo me mostrou pontos de vazamento energético que eu alimentava sem perceber. Em três meses, minha vida mudou completamente.",
    author: "Beatriz S., Designer"
  },
  {
    text: "Eu estava presa em um ciclo de abundância e escassez financeira há mais de uma década. Ganhava bem, mas sempre perdia tudo. A Mônica identificou um bloqueio estrutural profundo ligado à minha história familiar. Após o reequilíbrio, finalmente consigo acumular e crescer financeiramente.",
    author: "Isabela R., Médica"
  }];


  const whatsappLink = "https://wa.me/5581988671210?text=J%C3%A1%20preenchi%20minha%20Pr%C3%A9-Sele%C3%A7%C3%A3o%20para%20a%20Leitura%20do%20Campo%20Vibracional.%20";

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-violet-deep via-violet-medium to-rose-deep/40 flex items-center justify-center">
        <div className="text-white text-xl">Carregando...</div>
      </div>);

  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-violet-deep via-violet-medium to-rose-deep/40">
      {/* Success Message */}
      <section className="max-w-3xl mx-auto px-6 py-16 md:py-24">
        <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl p-8 md:p-12 text-center border border-violet-dust/30">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-green-100 mb-6">
            <CheckCircle className="w-12 h-12 text-green-600" />
          </div>
          
          <h1 className="font-serif text-3xl md:text-5xl font-bold text-violet-deep mb-6">Recebi suas respostas.</h1>
          
          <p className="font-sans text-gray-700 text-base md:text-lg leading-relaxed mb-4">
            Obrigada pela honestidade. Você trouxe algo real aqui. E o que você descreveu tem uma raiz que pode ser revelada.
          </p>
          
          <p className="font-sans text-gray-700 text-base md:text-lg leading-relaxed mb-4">
            Vou ler tudo com atenção antes de entrar em contato. Não é automático. Sou eu mesma que vou ler.
          </p>
          
          <p className="font-sans text-gray-700 text-base md:text-lg leading-relaxed mb-4">
            Você vai receber meu contato pessoal no WhatsApp em até 48 horas.
          </p>
          
          <p className="font-sans text-gray-700 text-base md:text-lg leading-relaxed mb-4">
            Só uma coisa enquanto aguarda: preste atenção no que aparecer em você nos próximos dias. Às vezes só o ato de nomear o que está travado já começa a mover algo.
          </p>
          
          <p className="font-sans text-gray-700 text-base md:text-lg leading-relaxed font-medium">
            Com amor,<br/>
            Mônica Maria, Reacenda Luz.
          </p>
        </div>
      </section>




    </div>);

}